import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67ad7f92"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "title" }, [
    /*#__PURE__*/_createTextVNode(" Forms "),
    /*#__PURE__*/_createElementVNode("div", {
      class: "btn btn-outline-dark me-4",
      "data-bs-toggle": "modal",
      "data-bs-target": "#addFormModal"
    }, " Add ")
  ])
], -1))
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "card-body ps-0 pe-0" }
const _hoisted_5 = { class: "table table-hover" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, [
      /*#__PURE__*/_createElementVNode("b", null, "Name")
    ]),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, [
      /*#__PURE__*/_createElementVNode("b", null, "Create")
    ]),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, [
      /*#__PURE__*/_createElementVNode("b", null, "Update")
    ]),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-end"
    })
  ])
], -1))
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_context_menu = _resolveComponent("context-menu")!
  const _component_add_form_modal = _resolveComponent("add-form-modal")!
  const _component_rename_form_modal = _resolveComponent("rename-form-modal")!
  const _component_delete_form_modal = _resolveComponent("delete-form-modal")!
  const _component_clone_form_modal = _resolveComponent("clone-form-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  class: _normalizeClass(["cursor-pointer", { odd: index }]),
                  key: item.taskId
                }, [
                  _createElementVNode("td", {
                    onClick: ($event: any) => (_ctx.go(item.formId))
                  }, _toDisplayString(item.name), 9, _hoisted_7),
                  _createElementVNode("td", {
                    onClick: ($event: any) => (_ctx.go(item.formId))
                  }, _toDisplayString(_ctx.format(item.createdAt)), 9, _hoisted_8),
                  _createElementVNode("td", {
                    onClick: ($event: any) => (_ctx.go(item.formId))
                  }, _toDisplayString(_ctx.format(item.updatedAt)), 9, _hoisted_9),
                  _createElementVNode("td", _hoisted_10, [
                    _createVNode(_component_context_menu, {
                      onClick: _withModifiers(($event: any) => (_ctx.selectedItemId = item.formId), ["stop"]),
                      id: index,
                      links: [
                    {
                      text: 'Rename',
                      icon: 'edit-3',
                      bsTarget: '#renameFormModal',
                    },
                    {
                      text: 'Preview',
                      icon: 'eye',
                      router: { name : 'settings-form-viewer', params: { formId: item.formId } },
                    }, {
                      text: 'Clone',
                      icon: 'copy',
                      bsTarget:'#cloneFormModal'
                    },{
                      text: 'Edit',
                      icon: 'edit',
                      router: { name : 'settings-form-editor', params: { formId: item.formId } },
                    },
                    {
                      text: 'Delete',
                      icon: 'trash-2',
                      bsTarget: '#deleteFormTemplateModal',
                    },
                  ]
                    }, null, 8, ["onClick", "id", "links"])
                  ])
                ], 2))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_add_form_modal),
    _createVNode(_component_rename_form_modal, { formId: _ctx.selectedItemId }, null, 8, ["formId"]),
    _createVNode(_component_delete_form_modal, { formId: _ctx.selectedItemId }, null, 8, ["formId"]),
    _createVNode(_component_clone_form_modal, { formId: _ctx.selectedItemId }, null, 8, ["formId"])
  ]))
}